export default () => {
  let clientTimeZone = 'America/New_York';
  let isTimeZoneForced = true;

  if (
    typeof window !== 'undefined' &&
    typeof window.Intl !== 'undefined' &&
    window.Intl.DateTimeFormat().resolvedOptions().timeZone
  ) {
    clientTimeZone = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    isTimeZoneForced = false;
  }

  return {
    isTimeZoneForced,
    clientTimeZone,
  };
};
